import React, { useCallback } from 'react';

import { IconsEnum } from '../../../../../../../assets/icons/types';

import {
  LifestylesFiltersNavBasePath,
  ChangeLifestylesFiltersFunc
} from '../../../../../lifestylesTypes';

import { LifestylesIndexPageCategoriesNavCategory } from '../../LifestylesIndexPageCategoriesNav.types';

import { NextLinkHelper } from '../../../../../../../helpers/links/NextLinkHelper';
import { Icon } from '../../../../../../../helpers/Icon';

import { LifestylePath } from '../../../../../LifestylePath';
import { getChangeLifestylesFiltersCategoriesData } from '../../../../../utils/getChangeLifestylesFiltersCategoriesData';

interface LifestylesIndexPageCategoriesNavItemProps {
  categories: LifestylesIndexPageCategoriesNavCategory[];
  category: LifestylesIndexPageCategoriesNavCategory;
  changeLifestylesFilters: ChangeLifestylesFiltersFunc;
  filtersNavBasePath?: LifestylesFiltersNavBasePath;
  withChevron?: boolean;
}

function LifestylesIndexPageCategoriesNavItem({
  categories,
  category,
  changeLifestylesFilters,
  filtersNavBasePath,
  withChevron
}: LifestylesIndexPageCategoriesNavItemProps) {
  const handleLinkClick = useCallback<
    (e: React.MouseEvent<HTMLAnchorElement>) => void
  >(
    (e) => {
      if (!filtersNavBasePath) {
        e.preventDefault();
        const { changeFilters, resetFilters } =
          getChangeLifestylesFiltersCategoriesData({
            lifestyleCategory: category,
            categories
          });

        changeLifestylesFilters(changeFilters, resetFilters);
      }
    },
    [filtersNavBasePath, category, categories, changeLifestylesFilters]
  );

  return (
    <div className="-mx-4">
      <div className="flex items-center group relative px-4 py-2 transition-colors ease-in-out duration-150 focus-within:ring-2 focus-within:ring-gray-850 dark:focus-within:ring-gray-100 bg-gray-500 bg-opacity-0 hover:bg-opacity-20">
        <NextLinkHelper
          className="focus:outline-none flex-1 px-2 text-sm"
          dataGa={`lifestyles-categories-filter-${
            category.nameEn || category.localizedName
          }`}
          href={
            filtersNavBasePath
              ? LifestylePath.indexFiltersCustomBaseQuery(
                  filtersNavBasePath,
                  getChangeLifestylesFiltersCategoriesData({
                    lifestyleCategory: category,
                    categories
                  }).changeFilters
                )
              : '#'
          }
          onClick={handleLinkClick}
        >
          {category.localizedName}
          <span className="absolute inset-0" aria-hidden="true" />
        </NextLinkHelper>

        {withChevron && (
          <Icon
            icon={IconsEnum.CHEVRON_RIGHT}
            className="h-5 w-5 flex-shrink-0"
          />
        )}
      </div>
    </div>
  );
}

export default LifestylesIndexPageCategoriesNavItem;
